// extracted by mini-css-extract-plugin
export var galleryGridColumn = "GalleryGridColumn-module--galleryGridColumn--a483b";
export var offset = "GalleryGridColumn-module--offset--a53b4";